import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {PosterEditorTranscriptActiveWordPanelProps} from '@Panels/poster-editor-transcript-active-word-panel/poster-editor-transcript-active-word-panel.types';

export const PANEL_ID = 'poster-editor-transcript-active-word-panel';

export const openPosterEditorTranscriptActiveWordModal = (props?: PosterEditorTranscriptActiveWordPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_TRANSCRIPT_ACTIVE_WORD_MODAL,
      panelProps: {
        panelId: PANEL_ID,
        ...props,
      },
    })
  );
};
